module.exports = __webpack_public_path__ + "static/media/album-music.9886b30c.svg";